export default "__VITE_ASSET__8b65f399__"